/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Device } from './Device';
import {
    DeviceFromJSON,
    DeviceFromJSONTyped,
    DeviceToJSON,
} from './Device';
import type { LicenseDetail } from './LicenseDetail';
import {
    LicenseDetailFromJSON,
    LicenseDetailFromJSONTyped,
    LicenseDetailToJSON,
} from './LicenseDetail';
import type { LicensedStatus } from './LicensedStatus';
import {
    LicensedStatusFromJSON,
    LicensedStatusFromJSONTyped,
    LicensedStatusToJSON,
} from './LicensedStatus';
import type { MinimalLicense } from './MinimalLicense';
import {
    MinimalLicenseFromJSON,
    MinimalLicenseFromJSONTyped,
    MinimalLicenseToJSON,
} from './MinimalLicense';
import type { MinimalTenant } from './MinimalTenant';
import {
    MinimalTenantFromJSON,
    MinimalTenantFromJSONTyped,
    MinimalTenantToJSON,
} from './MinimalTenant';

/**
 * 
 * @export
 * @interface TenantSeat
 */
export interface TenantSeat {
    /**
     * 
     * @type {string}
     * @memberof TenantSeat
     */
    readonly id: string;
    /**
     * 
     * @type {MinimalLicense}
     * @memberof TenantSeat
     */
    readonly license: MinimalLicense | null;
    /**
     * 
     * @type {Date}
     * @memberof TenantSeat
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Device}
     * @memberof TenantSeat
     */
    readonly device: Device;
    /**
     * 
     * @type {string}
     * @memberof TenantSeat
     */
    readonly controller: string | null;
    /**
     * 
     * @type {LicensedStatus}
     * @memberof TenantSeat
     */
    readonly licensedStatus: LicensedStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantSeat
     */
    readonly licensedEditions: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantSeat
     */
    readonly directLicensedEditions: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantSeat
     */
    readonly unlicensedEditions: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantSeat
     */
    readonly licenseNumbers: Array<string>;
    /**
     * 
     * @type {Array<LicenseDetail>}
     * @memberof TenantSeat
     */
    readonly licenseDetail: Array<LicenseDetail>;
    /**
     * 
     * @type {string}
     * @memberof TenantSeat
     */
    readonly url: string | null;
    /**
     * 
     * @type {MinimalTenant}
     * @memberof TenantSeat
     */
    readonly tenant: MinimalTenant;
}

/**
 * Check if a given object implements the TenantSeat interface.
 */
export function instanceOfTenantSeat(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "license" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "device" in value;
    isInstance = isInstance && "controller" in value;
    isInstance = isInstance && "licensedStatus" in value;
    isInstance = isInstance && "licensedEditions" in value;
    isInstance = isInstance && "directLicensedEditions" in value;
    isInstance = isInstance && "unlicensedEditions" in value;
    isInstance = isInstance && "licenseNumbers" in value;
    isInstance = isInstance && "licenseDetail" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "tenant" in value;

    return isInstance;
}

export function TenantSeatFromJSON(json: any): TenantSeat {
    return TenantSeatFromJSONTyped(json, false);
}

export function TenantSeatFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSeat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'license': MinimalLicenseFromJSON(json['license']),
        'createdAt': (new Date(json['created_at'])),
        'device': DeviceFromJSON(json['device']),
        'controller': json['controller'],
        'licensedStatus': LicensedStatusFromJSON(json['licensed_status']),
        'licensedEditions': json['licensed_editions'],
        'directLicensedEditions': json['direct_licensed_editions'],
        'unlicensedEditions': json['unlicensed_editions'],
        'licenseNumbers': json['license_numbers'],
        'licenseDetail': ((json['license_detail'] as Array<any>).map(LicenseDetailFromJSON)),
        'url': json['url'],
        'tenant': MinimalTenantFromJSON(json['tenant']),
    };
}

export function TenantSeatToJSON(value?: TenantSeat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

